import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Web Awesome theme styles (the app's esbuild builder handles CSS imports here).
import '@web.awesome.me/webawesome-pro/dist/styles/themes/default.css';
import '@web.awesome.me/webawesome-pro/dist/styles/native.css';

// Web Awesome registration (component custom elements, base path, Font Awesome kit).
// Shared with Storybook via .storybook/preview.ts so the catalog matches the app.
import './web-awesome';

declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Window {
        __appViewportHeightInitialized?: boolean;
    }
}

const _registerViewportHeightCssVariable = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    if (window.__appViewportHeightInitialized) {
        return;
    }

    window.__appViewportHeightInitialized = true;

    const setViewportHeight = () => {
        const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
        document.documentElement.style.setProperty('--app-viewport-height', `${viewportHeight}px`);
    };

    setViewportHeight();

    window.addEventListener('resize', setViewportHeight);
    window.addEventListener('orientationchange', setViewportHeight);
    window.addEventListener('pageshow', setViewportHeight);
    window.visualViewport?.addEventListener('resize', setViewportHeight);
};

// registerViewportHeightCssVariable();

bootstrapApplication(App, appConfig).catch(err => console.error(err));
